module.exports = __webpack_public_path__ + "img/comment1.9bcaf40d.png";